
import "./Header.css"

function Header(){
    return(<div className="header" >
        Tech Blogs
    </div>)
}

export default Header;